/**
 * @generated SignedSource<<bc0444a9f293bda024c2aacdf207e71a>>
 * @relayHash ba9a05ea6acaa4076adb348df8eb72ce
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ba9a05ea6acaa4076adb348df8eb72ce

import { ConcreteRequest } from 'relay-runtime';
export type chEpisodeOfCareAiSuggestionsQuery$variables = {
  appointmentId: string;
};
export type chEpisodeOfCareAiSuggestionsQuery$data = {
  readonly suggestedEpisodeOfCareIcdDiagnoses: ReadonlyArray<{
    readonly diagnosisCode: string;
    readonly id: string;
    readonly text: string;
  }>;
};
export type chEpisodeOfCareAiSuggestionsQuery = {
  response: chEpisodeOfCareAiSuggestionsQuery$data;
  variables: chEpisodeOfCareAiSuggestionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "appointmentId"
  }
],
v1 = [
  {
    "alias": "suggestedEpisodeOfCareIcdDiagnoses",
    "args": [
      {
        "kind": "Variable",
        "name": "appointmentId",
        "variableName": "appointmentId"
      }
    ],
    "concreteType": "IcdDiagnosis",
    "kind": "LinkedField",
    "name": "ch_suggestedEpisodeOfCareIcdDiagnoses",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "diagnosisCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "text",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "chEpisodeOfCareAiSuggestionsQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "chEpisodeOfCareAiSuggestionsQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "ba9a05ea6acaa4076adb348df8eb72ce",
    "metadata": {},
    "name": "chEpisodeOfCareAiSuggestionsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "72d3636feab63aa2d1aaf9d1f57e55fd";

export default node;
